import { Base2Presenter } from "core/presenter";
import { pathOr } from "ramda";

export default class CompanyIntegrationsMercadoPagoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      company: {
        integrations: {
          mercado_pago: {
            enabled: false,
            token: ""
          }
        }
      }
    };
  }

  onStart() {
    this.checkIntegration();
  }

  checkIntegration() {
    const { company } = this.props;
    const { mercado_pago } = company.integrations;

    if (mercado_pago) {
      this.enqueue({
        company: {
          integrations: {
            mercado_pago
          }
        }
      });
    }

    const integrationEnabled = pathOr(
      false,
      ["integrations", "mercado_pago", "enabled"],
      company
    );
    this.enqueueMercadoPagoField("enabled", integrationEnabled);
  }

  manageCheckbox(checked) {
    this.enqueue({ loading: true });
    this.enqueueMercadoPagoField("enabled", checked);
    this.enqueue({ loading: false });
  }

  enqueueMercadoPagoField(field, value) {
    this.enqueue(
      vm => ({
        company: {
          ...vm.company,
          integrations: {
            ...vm.company.integrations,
            mercado_pago: {
              ...vm.company.integrations.mercado_pago,
              [field]: value
            }
          }
        }
      }),
      () => this.updateMercadoPagoIntegration()
    );
  }

  updateMercadoPagoIntegration() {
    const mercado_pago = this.viewModel.company.integrations.mercado_pago;
    this.props.company.integrations.mercado_pago = mercado_pago;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/mercado-pago/presenter.js